if (!customElements.get('quiz-pet-component')) {
  customElements.define(
    'quiz-pet-component',
    class QuizPetComponent extends HTMLElement {
      constructor() {
        super();
        this.currentQuestion = 0;
        this.answers = {};
        this.scores = {};
        this.totalQuestions = 7;
        this.showingLeadCapture = false;
        this.leadData = { name: '', email: '' };

        this.questionConfig = [
          {
            id: 'q1',
            type: 'radio',
            noneIndex: -1,
            points: [
              { nutripet: 2 },
              { longevidade: 1 },
              { senior: 3 }
            ]
          },
          {
            id: 'q2',
            type: 'checkbox',
            noneIndex: 3,
            points: [
              { zenpet: 3 },
              { zenpet: 3 },
              { zenpet: 2 },
              {}
            ]
          },
          {
            id: 'q3',
            type: 'radio',
            noneIndex: -1,
            points: [
              { longevidade: 1 },
              { vitalypet: 2 },
              { vitalypet: 2 },
              { senior: 3 }
            ]
          },
          {
            id: 'q4',
            type: 'checkbox',
            noneIndex: 3,
            points: [
              { flex: 3 },
              { flex: 3 },
              { flex: 2 },
              {}
            ]
          },
          {
            id: 'q5',
            type: 'checkbox',
            noneIndex: 3,
            points: [
              { 'omega-complex': 3 },
              { 'omega-complex': 3 },
              { 'omega-complex': 2 },
              {}
            ]
          },
          {
            id: 'q6',
            type: 'checkbox',
            noneIndex: 4,
            points: [
              { nutripet: 3 },
              { nutripet: 3 },
              { nutripet: 2 },
              { nutripet: 2 },
              {}
            ]
          },
          {
            id: 'q7',
            type: 'checkbox',
            noneIndex: 4,
            points: [
              { cranberry: 3 },
              { cranberry: 2 },
              { optdog: 3 },
              { freshlife: 3 },
              {}
            ]
          }
        ];

        this.defaultUrls = {
          zenpet: '/products/hoop-suplemento-zenpet',
          senior: '/products/hoop-suplemento-senior',
          vitalypet: '/products/hoop-suplemento-vitalypet',
          longevidade: '/products/hoop-suplemento-longevidade',
          nutripet: '/products/hoop-suplemento-nutripet',
          freshlife: '/products/hoop-suplemento-freshlife',
          'omega-complex': '/products/hoop-suplemento-omega-complex',
          cranberry: '/products/hoop-suplemento-cranberry',
          optdog: '/products/hoop-suplemento-optdog',
          flex: '/products/hoop-suplemento-flex'
        };
      }

      connectedCallback() {
        this.loadEditorData();
        this.bindEvents();

        const formPosted = this.editorData && this.editorData.formPosted;
        if (formPosted) {
          const savedWinners = JSON.parse(localStorage.getItem('quiz-pet-winners') || 'null');
          localStorage.removeItem('quiz-pet-winners');
          if (savedWinners && savedWinners.length) {
            this.renderResult(savedWinners);
            return;
          }
        }

        this.renderIntro();
      }

      loadEditorData() {
        const script = this.querySelector('script[data-quiz-pet-data]');
        if (script) {
          try {
            this.editorData = JSON.parse(script.textContent);
          } catch (e) {
            this.editorData = null;
          }
        }

        this.questions = this.questionConfig.map((config, index) => {
          const editorQ = this.editorData && this.editorData.questions[index];
          return {
            id: config.id,
            type: config.type,
            question: editorQ ? editorQ.question : '',
            noneIndex: config.noneIndex,
            options: config.points.map((pts, i) => ({
              label: editorQ ? editorQ.options[i] : '',
              points: pts
            }))
          };
        });

        this.productResults = {};
        const productKeys = ['zenpet', 'senior', 'vitalypet', 'longevidade', 'nutripet', 'freshlife', 'omega-complex', 'cranberry', 'optdog', 'flex'];
        productKeys.forEach((key) => {
          const editorR = this.editorData && this.editorData.results[key];
          this.productResults[key] = {
            title: editorR ? editorR.title : '',
            text: editorR ? editorR.text : '',
            cta: editorR ? editorR.cta : '',
            url: (editorR && editorR.url) || this.defaultUrls[key],
            image: (editorR && editorR.image) || ''
          };
        });

        this.introText = (this.editorData && this.editorData.introText) || 'Responda 7 perguntas rápidas e descubra qual suplemento é o mais indicado para as necessidades do seu pet.';
        this.startButtonText = (this.editorData && this.editorData.startButtonText) || 'Começar Quiz';
        this.introImage = (this.editorData && this.editorData.introImage) || '';

        const leadConfig = (this.editorData && this.editorData.leadCapture) || {};
        this.leadEnabled = leadConfig.enabled !== undefined ? leadConfig.enabled : true;
        this.leadTitle = leadConfig.title || 'Último passo! Precisamos do seu nome e email para salvar a recomendação do(a) teste e gerar o desconto de R$30,00 em sua compra!*';
        this.leadSubtitle = leadConfig.subtitle || '*Desconto válido para primeira compra.';
        this.leadNamePlaceholder = leadConfig.namePlaceholder || 'José';
        this.leadEmailPlaceholder = leadConfig.emailPlaceholder || 'alguem@exemplo.com';
        this.leadButtonText = leadConfig.buttonText || 'Ver minha recomendação';
        this.leadDisclaimer = leadConfig.disclaimer || 'Ao continuar, você concorda em receber comunicações por e-mail. Seus dados estão seguros.';
        this.totalSteps = this.leadEnabled ? this.totalQuestions + 1 : this.totalQuestions;
      }

      bindEvents() {
        const liquidForm = document.getElementById('quiz-pet-lead-form');
        if (liquidForm) {
          liquidForm.setAttribute('novalidate', '');
          liquidForm.addEventListener('submit', (e) => {
            const valid = this.validateLeadForm();
            if (!valid) {
              e.preventDefault();
            } else {
              localStorage.setItem('quiz-pet-winners', JSON.stringify(this.computeWinners()));
            }
          });
        }

        this.addEventListener('click', (e) => {
          const target = e.target;
          if (target.closest('.quiz-pet__btn-start')) {
            this.startQuiz();
          } else if (target.closest('.quiz-pet__btn-next')) {
            this.nextQuestion();
          } else if (target.closest('.quiz-pet__btn-prev')) {
            this.prevQuestion();
          } else if (target.closest('.quiz-pet__btn-restart')) {
            this.restartQuiz();
          }
        });

        this.addEventListener('change', (e) => {
          const input = e.target;
          if (input.type === 'checkbox' || input.type === 'radio') {
            this.handleSelection(input);
          }
        });
      }

      renderIntro() {
        const content = this.querySelector('.quiz-pet__content');
        if (!content) return;

        const introImageHtml = this.introImage
          ? `<div class="quiz-pet__intro-image">
              <img src="${this.introImage}" alt="" loading="lazy" width="800">
            </div>`
          : `<div class="quiz-pet__intro-icon">
              <svg width="40" height="40" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 8c-4 0-7 3-7 7s2 8 7 8 7-4 7-8-3-7-7-7zm24 0c-4 0-7 3-7 7s3 8 7 8 7-4 7-8-3-7-7-7zM10 28c-4 0-7 3-7 7s3 8 7 8 7-4 7-8-3-7-7-7zm44 0c-4 0-7 3-7 7s3 8 7 8 7-4 7-8-3-7-7-7zM32 30c-8 0-15 6-15 14 0 6 4 11 9 13 2 1 4 1 6 1s4 0 6-1c5-2 9-7 9-13 0-8-7-14-15-14z" fill="currentColor" opacity="0.3"/>
                <path d="M20 8c-4 0-7 3-7 7s2 8 7 8 7-4 7-8-3-7-7-7zm24 0c-4 0-7 3-7 7s3 8 7 8 7-4 7-8-3-7-7-7zM10 28c-4 0-7 3-7 7s3 8 7 8 7-4 7-8-3-7-7-7zm44 0c-4 0-7 3-7 7s3 8 7 8 7-4 7-8-3-7-7-7zM32 30c-8 0-15 6-15 14 0 6 4 11 9 13 2 1 4 1 6 1s4 0 6-1c5-2 9-7 9-13 0-8-7-14-15-14z" stroke="currentColor" stroke-width="2" fill="none"/>
              </svg>
            </div>`;

        content.innerHTML = `
          <div class="quiz-pet__intro">
            ${introImageHtml}
            <p class="quiz-pet__intro-text">${this.introText}</p>
            <button type="button" class="quiz-pet__btn-start button button--primary">${this.startButtonText}</button>
          </div>
        `;
      }

      startQuiz() {
        this.currentQuestion = 0;
        this.answers = {};
        this.scores = {};
        this.showingLeadCapture = false;
        this.leadData = { name: '', email: '' };
        this.renderQuestion();
      }

      buildProgressHtml(stepOverride) {
        const currentStep = stepOverride !== undefined ? stepOverride : this.currentQuestion;
        const checkSvg = '<svg class="quiz-pet__step-check" width="14" height="14" viewBox="0 0 18 18" fill="none"><path d="M4 9l3.5 3.5L14 5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        let stepsHtml = '';
        for (let i = 0; i < this.totalSteps; i++) {
          let cls = 'quiz-pet__step';
          if (i < currentStep) cls += ' quiz-pet__step--done';
          else if (i === currentStep) cls += ' quiz-pet__step--active';

          stepsHtml += `<div class="${cls}"><span class="quiz-pet__step-num">${i + 1}</span>${checkSvg}</div>`;
        }

        const totalWidth = this.totalSteps - 1;
        const filledWidth = currentStep / totalWidth;
        const linePercent = filledWidth * 100;

        return `
          <div class="quiz-pet__progress">
            <div class="quiz-pet__progress-steps">
              <div class="quiz-pet__progress-line" style="width: calc(${linePercent}% - ${linePercent > 0 ? 0 : 16}px)"></div>
              ${stepsHtml}
            </div>
          </div>
        `;
      }

      renderQuestion() {
        const q = this.questions[this.currentQuestion];
        const content = this.querySelector('.quiz-pet__content');
        if (!content) return;

        const savedAnswers = this.answers[q.id] || [];
        const isFirst = this.currentQuestion === 0;
        const isLast = this.currentQuestion === this.totalQuestions - 1;

        let optionsHtml = '';
        q.options.forEach((opt, i) => {
          const inputId = `${q.id}-opt-${i}`;
          const inputType = q.type;
          const inputName = q.type === 'radio' ? q.id : inputId;
          const isChecked = savedAnswers.includes(i) ? 'checked' : '';
          const isNone = q.noneIndex === i;

          optionsHtml += `
            <label class="quiz-pet__option ${isChecked ? 'quiz-pet__option--selected' : ''}" for="${inputId}">
              <input type="${inputType}" id="${inputId}" name="${inputName}" value="${i}" ${isChecked}
                ${isNone ? 'data-none="true"' : ''}>
              <span class="quiz-pet__option-check">
                <svg width="14" height="14" viewBox="0 0 18 18" fill="none">
                  <path d="M4 9l3.5 3.5L14 5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <span class="quiz-pet__option-label">${opt.label}</span>
            </label>
          `;
        });

        const hintHtml = q.type === 'checkbox'
          ? `<p class="quiz-pet__hint">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4m0-4h.01"/></svg>
              Você pode selecionar mais de uma opção
            </p>`
          : '';

        const prevBtnHtml = !isFirst
          ? `<button type="button" class="quiz-pet__btn-prev quiz-pet__btn-nav">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5m7-7-7 7 7 7"/></svg>
              Anterior
            </button>`
          : '<span></span>';

        content.innerHTML = `
          ${this.buildProgressHtml()}
          <div class="quiz-pet__question-wrap">
            <h3 class="quiz-pet__question">${q.question}</h3>
            ${hintHtml}
            <div class="quiz-pet__options" role="group" aria-label="${q.question}">
              ${optionsHtml}
            </div>
          </div>
          <div class="quiz-pet__nav">
            ${prevBtnHtml}
            <button type="button" class="quiz-pet__btn-next button button--primary quiz-pet__btn-nav">${isLast ? 'Ver Resultado' : 'Próximo'}</button>
          </div>
        `;

        this.closest('.quiz-pet').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      handleSelection(input) {
        const q = this.questions[this.currentQuestion];
        const questionContainer = input.closest('.quiz-pet__options');
        if (!questionContainer) return;

        if (q.type === 'radio') {
          questionContainer.querySelectorAll('.quiz-pet__option').forEach((label) => {
            label.classList.remove('quiz-pet__option--selected');
          });
          input.closest('.quiz-pet__option').classList.add('quiz-pet__option--selected');
          this.answers[q.id] = [parseInt(input.value)];
        } else {
          const isNone = input.dataset.none === 'true';
          if (isNone && input.checked) {
            questionContainer.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
              if (cb !== input) {
                cb.checked = false;
                cb.closest('.quiz-pet__option').classList.remove('quiz-pet__option--selected');
              }
            });
          } else if (!isNone && input.checked) {
            const noneInput = questionContainer.querySelector('input[data-none="true"]');
            if (noneInput) {
              noneInput.checked = false;
              noneInput.closest('.quiz-pet__option').classList.remove('quiz-pet__option--selected');
            }
          }

          if (input.checked) {
            input.closest('.quiz-pet__option').classList.add('quiz-pet__option--selected');
          } else {
            input.closest('.quiz-pet__option').classList.remove('quiz-pet__option--selected');
          }

          const selected = [];
          questionContainer.querySelectorAll('input[type="checkbox"]:checked').forEach((cb) => {
            selected.push(parseInt(cb.value));
          });
          this.answers[q.id] = selected;
        }
      }

      nextQuestion() {
        const q = this.questions[this.currentQuestion];
        const selected = this.answers[q.id] || [];
        if (selected.length === 0) {
          this.showValidation();
          return;
        }

        if (this.currentQuestion < this.totalQuestions - 1) {
          this.currentQuestion++;
          this.renderQuestion();
        } else if (this.leadEnabled && !this.showingLeadCapture) {
          this.showingLeadCapture = true;
          this.renderLeadCapture();
        } else {
          this.calculateResult();
        }
      }

      prevQuestion() {
        if (this.showingLeadCapture) {
          this.showingLeadCapture = false;
          const content = this.querySelector('.quiz-pet__content');
          const leadForm = document.getElementById('quiz-pet-lead-form');
          if (content) content.hidden = false;
          if (leadForm) leadForm.classList.remove('quiz-pet__lead-step--active');
          this.renderQuestion();
          return;
        }
        if (this.currentQuestion > 0) {
          this.currentQuestion--;
          this.renderQuestion();
        }
      }

      renderLeadCapture() {
        const content = this.querySelector('.quiz-pet__content');
        const leadForm = document.getElementById('quiz-pet-lead-form');
        if (!leadForm) return;

        if (content) content.hidden = true;
        leadForm.classList.add('quiz-pet__lead-step--active');

        const progressContainer = document.getElementById('quiz-pet-lead-progress');
        if (progressContainer) {
          progressContainer.innerHTML = this.buildProgressHtml(this.totalQuestions);
        }

        leadForm.querySelectorAll('.quiz-pet__lead-error').forEach((el) => { el.hidden = true; });
        leadForm.querySelectorAll('.quiz-pet__lead-input--error').forEach((el) => { el.classList.remove('quiz-pet__lead-input--error'); });

        this.closest('.quiz-pet').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      validateLeadForm() {
        const nameInput = document.getElementById('quiz-lead-name');
        const emailInput = document.getElementById('quiz-lead-email');
        const nameError = document.querySelector('.quiz-pet__lead-error[data-field="name"]');
        const emailError = document.querySelector('.quiz-pet__lead-error[data-field="email"]');

        const name = nameInput ? nameInput.value.trim() : '';
        const email = emailInput ? emailInput.value.trim() : '';
        let valid = true;

        if (nameError) nameError.hidden = true;
        if (emailError) emailError.hidden = true;
        if (nameInput) nameInput.classList.remove('quiz-pet__lead-input--error');
        if (emailInput) emailInput.classList.remove('quiz-pet__lead-input--error');

        if (!name) {
          if (nameError) nameError.hidden = false;
          if (nameInput) nameInput.classList.add('quiz-pet__lead-input--error');
          valid = false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailRegex.test(email)) {
          if (emailError) {
            emailError.hidden = false;
            if (email && !emailRegex.test(email)) {
              const errSvg = emailError.querySelector('svg');
              emailError.textContent = 'Informe um e-mail válido';
              if (errSvg) emailError.prepend(errSvg);
            }
          }
          if (emailInput) emailInput.classList.add('quiz-pet__lead-input--error');
          valid = false;
        }

        return valid;
      }

      computeWinners() {
        const scores = {};
        this.questions.forEach((q) => {
          const selected = this.answers[q.id] || [];
          selected.forEach((optIndex) => {
            const opt = q.options[optIndex];
            if (opt && opt.points) {
              Object.entries(opt.points).forEach(([product, pts]) => {
                scores[product] = (scores[product] || 0) + pts;
              });
            }
          });
        });

        const sorted = Object.entries(scores)
          .filter(([, pts]) => pts > 0)
          .sort((a, b) => b[1] - a[1]);

        if (sorted.length === 0) return ['longevidade'];
        if (sorted.length === 1) return [sorted[0][0]];
        if (sorted[0][1] === sorted[1][1]) return [sorted[0][0], sorted[1][0]];
        return [sorted[0][0]];
      }

      showValidation() {
        const content = this.querySelector('.quiz-pet__content');
        const existing = content.querySelector('.quiz-pet__validation');
        if (existing) return;

        const msg = document.createElement('p');
        msg.className = 'quiz-pet__validation';
        msg.textContent = 'Por favor, selecione pelo menos uma opção.';
        const nav = content.querySelector('.quiz-pet__nav');
        if (nav) nav.before(msg);

        setTimeout(() => msg.remove(), 3000);
      }

      calculateResult() {
        this.renderResult(this.computeWinners());
      }

      renderResult(winners) {
        const content = this.querySelector('.quiz-pet__content');
        if (!content) return;

        const isTie = winners.length > 1;
        const arrowSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14m-7-7 7 7-7 7"/></svg>';

        let resultsHtml = '';
        winners.forEach((key) => {
          const product = this.productResults[key];
          if (!product) return;
          const imageHtml = product.image
            ? `<div class="quiz-pet__result-image">
                <img src="${product.image}" alt="${product.title}" loading="lazy" width="600">
              </div>`
            : '';
          const hasImage = product.image ? ' quiz-pet__result-card--has-image' : '';
          resultsHtml += `
            <div class="quiz-pet__result-card${isTie ? ' quiz-pet__result-card--tie' : ''}${hasImage}">
              ${imageHtml}
              <div class="quiz-pet__result-info">
                <h3 class="quiz-pet__result-title">${product.title}</h3>
                <p class="quiz-pet__result-text">${product.text}</p>
                <a href="${product.url}" class="quiz-pet__result-cta button button--primary">${product.cta} ${arrowSvg}</a>
              </div>
            </div>
          `;
        });

        const badgeText = isTie ? 'Principais recomendações' : 'Resultado do Quiz';

        content.innerHTML = `
          <div class="quiz-pet__result">
            <div class="quiz-pet__result-badge">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="M22 4 12 14.01l-3-3"/></svg>
              ${badgeText}
            </div>
            ${isTie ? '<p class="quiz-pet__result-subtitle">Encontramos duas opções ideais para o seu pet</p>' : ''}
            <div class="quiz-pet__result-cards${isTie ? ' quiz-pet__result-cards--tie' : ''}">
              ${resultsHtml}
            </div>
            <button type="button" class="quiz-pet__btn-restart">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
              Refazer Quiz
            </button>
          </div>
        `;

        this.closest('.quiz-pet').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      restartQuiz() {
        const leadForm = document.getElementById('quiz-pet-lead-form');
        if (leadForm) leadForm.classList.remove('quiz-pet__lead-step--active');
        const content = this.querySelector('.quiz-pet__content');
        if (content) content.hidden = false;
        this.currentQuestion = 0;
        this.answers = {};
        this.scores = {};
        this.showingLeadCapture = false;
        this.leadData = { name: '', email: '' };
        this.renderIntro();
        this.closest('.quiz-pet').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  );
}
